import { atom } from 'jotai';

export const drawerStateAtom = atom(false);
